'use strict';

var _ = require('lodash'),
    util = require('../util'),
    ajax =  require('../ajax'),
    progress = require('../progress'),
    inventory = require('./');
    
var bornModules = require('../helpers/born.modules').default;

var availability = require('../pages/product/availability');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        var quickviewElement = $('.quickview__dialog');
        if(quickviewElement.length>0){
        	this.pid = quickviewElement.find('#pid').val();
        	var target = quickviewElement.find('.qty-input__ctrl.input--white.value');
        	var quickview = quickviewElement.find('.js-quickview').val();
        	var qty = quickviewElement.find('input[name="Quantity"]').val();
        } else {
            this.pid = $('input[name="pid"]').val();
            var target =document.getElementsByClassName("qty-input__ctrl input--white value");
            var quickview = $('.js-quickview').val();
            var qty = $('input[name="Quantity"]').val();
        }
        
        
        ajax.getJson({
            url: util.appendParamsToUrl(Urls.getAvailability, {
                pid: this.pid,
                Quantity: qty
            }),
            callback: function(data) {
                availability.updateContainer(data, $(target));
            }
        });
        
        var format = '';
        if (document.getElementById("requestFormat")) {
            format =  document.getElementById("requestFormat").value;
        }
        if(format != 'ajax' && pageContext && pageContext.ns != 'cart'){
            var $target = $(".variation-container").last();
            var selectedSizeGrid = $target.find('.size-conversion-container li.selected').text()!=''?$target.find('.size-conversion-container li.selected').text():$target.find('.size-conversion-container option:selected').text();
            var params = {
                    pid:this.pid,
                    quickview:quickview,
                    source:quickview=="true"? 'quickview' :'detail',
                    selectedSizeGrid:selectedSizeGrid
            };
            var URL = util.appendParamsToUrl(Urls.getVariationDropdown, params)
            var isSet = $target.attr('data-isSet');
            if(isSet!=='true'){
                progress.show($target);
                ajax.load({
                    url: URL,
                    target:$target,
                    callback: function (data) {
                        bornModules.selectTags.init();
                        bornModules.carousel.init();
                        if(quickview=="true"){
                            bornModules.showMoreSwatches.init('.quickview__dialog .swatch-variation-wrap');
                        }else{
                            bornModules.showMoreSwatches.init();
                        }
                        progress.hide($target);
                    }
                });
            }
           
        }
        
        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
    }
};

module.exports = productInventory;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/storeinventory/product.js